import styles from './ResetPasswordPage.module.scss';
import { BasePublicPage } from 'src/v2/pages/auth/BasePublicPage';
import { ResetPasswordForm } from 'src/v2/pages/auth/ResetPasswordPage/components/ResetPasswordForm/ResetPasswordForm';
import { AppRoutes } from 'src/types';
import { TextWithLinkSection } from 'src/v2/pages/auth/components/TextWithLinkSection';
import React from 'react';

export const ResetPasswordPage = () => {
  return (
    <BasePublicPage alignContainer="center">
      <div className={styles.mainSection}>
        <h2>Reset your password</h2>
        <ResetPasswordForm />
        <TextWithLinkSection
          text="Back to"
          linkText="Login"
          linkRoute={AppRoutes.LOGIN}
        />
      </div>
    </BasePublicPage>
  );
};
